import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialFeatured } from './components/TestimonialFeatured';
import { PainSection } from './components/PainSection';
import { ProductReveal } from './components/ProductReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCards } from './components/PricingCards';
import { CerebroDigital } from './components/CerebroDigital';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostSection } from './components/CostSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '1349873706968654');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-green-500/30 font-sans overflow-x-hidden space-y-[0px]" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1349873706968654&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <SocialProofBar data-id="element-4" />
      <TestimonialFeatured data-id="element-5" />
      <PainSection data-id="element-6" />

      <div className="bg-gradient-to-b from-[#0a0a0a] via-gray-900/20 to-[#0a0a0a]" data-id="element-7">
        <ProductReveal data-id="element-8" />
        <TomosSection data-id="element-9" />

        <div className="max-w-3xl mx-auto px-4 py-6" data-id="element-10">
          <div className="bg-green-900/10 border border-green-500/20 rounded-2xl p-5 md:p-6" data-id="element-11">
            <h3 className="text-xl font-bold text-green-400 mb-4 flex items-center gap-2" data-id="element-12">
              <span className="text-2xl" data-id="element-13">✅</span> Todo incluye:
            </h3>
            <ul className="space-y-3" data-id="element-14">
              {['Formularios imprimibles y digitales', 'Protocolos basados en evidencia actualizada', 'Adaptado 100% al contexto argentino 2025', 'Normativa argentina vigente (Leyes 26.529 · 27.642)', 'Listo para usar desde la primera consulta'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-15">
                  <span className="text-green-500 mt-1" data-id="element-16">✓</span> {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <BonusSection data-id="element-17" />
      <CountdownTimer data-id="element-18" />
      <PricingCards data-id="element-19" />
      <CerebroDigital data-id="element-20" />
      <TestimonialsSection data-id="element-21" />
      <GuaranteeSection data-id="element-22" />
      <FAQSection data-id="element-23" />
      <CostSection data-id="element-24" />
      <FinalCTA data-id="element-25" />
      <Footer data-id="element-26" />
      <SocialProofToast data-id="element-27" />
    </div>;
}